import { render, staticRenderFns } from "./AdministrativeCenters.vue?vue&type=template&id=6d9a5b3f&scoped=true"
import script from "./AdministrativeCenters.vue?vue&type=script&lang=js"
export * from "./AdministrativeCenters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9a5b3f",
  null
  
)

export default component.exports